import script from "./CouponChooser.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponChooser.vue?vue&type=script&setup=true&lang=js"

import "./CouponChooser.vue?vue&type=style&index=0&id=a1639e18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\19612-frontline\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1639e18"]])

export default __exports__